import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';

// Return a list of all object type ids that can be used in the lists tool
const getAvailableListObjects = ({
  isUngatedForDealObjectLists = false
} = {}) => {
  const listObjectTypeIds = ['0-1', '0-2', '0-5', '0-123', '0-142'];
  if (isUngatedForDealObjectLists) listObjectTypeIds.push('0-3');
  return listObjectTypeIds;
};
export const isObjectTypeIdAllowedForLists = (objectTypeId, {
  isUngatedForDealObjectLists
}) => {
  const objectTypesWithLists = getAvailableListObjects({
    isUngatedForDealObjectLists
  });
  return objectTypesWithLists.includes(objectTypeId) || isCustomObject(objectTypeId);
};